export default "__VITE_ASSET__52e9fa60__"